import styled from 'styled-components';
import {
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Button as ButtonLayoutComponent } from '@playbookux/playbook-web-core';

export const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

export const ContainerButton = styled.div`
  padding: 20px;
`;

export const InviteButton = styled(ButtonLayoutComponent)`
`;

export const Icon = styled(SemanticIcon)`
  &&& {
    color: ${(props) => props.theme.color.primary}
  }
`;
